/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_Loss_SeatsInputs */



/**
* | output |
* | --- |
* | "Unlimited seats (capped at 5)" |
*
* @param {Plan_Tab_Downgrade_Loss_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_loss_seats = /** @type {((inputs?: Plan_Tab_Downgrade_Loss_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_Loss_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzte Plätze (auf 5 begrenzt)")
	return /** @type {LocalizedString} */ ("Unlimited seats (capped at 5)")
});